import ImageUploadComponent from 'components/ImageUploadComponent';
import React, { useState } from 'react';
import { createComparableItem } from 'services/api/inventoryItems';
import { DATE_FORMATS, formatDate, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DecimalInput from 'components/DecimalInput';

const AddComparableItemModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [unit, setUnit] = useState<string>('');
  const [price, setPrice] = useState<number>(0);
  const [source, setSource] = useState<string>('');
  const [image, setImage] = useState<string | File>();
  const [date, setDate] = useState<string | null>(null);
  const { itemId, onSuccess, toggleModal } = props;

  const addComparableItem = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      id: itemId,
      source,
      unit,
      date,
      price,
      image,
    };
    try {
      await createComparableItem(data);
      showSuccess('Related Item added successfully');
      await onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Add A New Comparable Item</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['image-section']}>
            <div className={styles['image-container']}>
              <ImageUploadComponent
                src={''}
                entityId={''}
                toggleModal={() => { }}
                uploadAPI={(id, image) => setImage(image)}
              />
            </div>
          </div>
          <div className={styles['input-section']}>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Unit</div>
              <input
                disabled={loading}
                className={'form-control'}
                onChange={e => setUnit(e.target.value)}
              />
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Source</div>
              <input
                disabled={loading}
                className={'form-control'}
                onChange={e => setSource(e.target.value)}
              />
            </div>
            <div className={'d-flex justify-content-between'}>
              <div className={styles['price']}>
                <div className={styles['label']}>Price</div>
                <DecimalInput
                  value={price}
                  disabled={loading}
                  onChange={setPrice}
                />
              </div>
              <div className={''}>
                <div className={styles['label']}>Date</div>
                <div className={styles['date-picker']}>
                  <DatePicker
                    disabled={loading}
                    className={'form-control'}
                    selected={date ? moment(date).toDate() : null}
                    onChange={(e: any) => setDate(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addComparableItem}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddComparableItemModal;
